export const tooltipStyles =
   'opacity-[1] !text-xs !font-semibold rounded-[8px] bg-gray-900 px-[12px] py-[8px]'
